import React, { useMemo, useState } from 'react';
import './TechnicalDetails.scss';
import { getSpecs } from '../helper';
import { useSelector } from 'react-redux';
import Collapse from '../Collapse/Collapse';

const TechnicalDetails = ({ specifications, productId, isAccessories, productColorCode }) => {
  const dataLocale = useSelector(state => state.locale);
  const { PRODUCT_DETAILS } = dataLocale;
  const [showAll, setShowAll] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const specs = useMemo(() => {
    return getSpecs(specifications, dataLocale);
  }, [dataLocale, specifications]);

  const visibleSpecs = showAll ? specs : specs?.slice(0, 5);
  const remainingCount = specs?.length > 5 ? specs.length - 5 : 0;

  return (
    <>
      <div className={`od-pc-technical-details ${isAccessories ? 'hidden' : ''}`}>
        <Collapse defaultOpen title={PRODUCT_DETAILS}>
          {specs?.length > 0 && (
            <>
              <dl>
                {productId && (
                  <>
                    <dt>Product ID</dt>
                    <dd>{productId}</dd>
                  </>
                )}
                {visibleSpecs?.map(
                  item =>
                    item?.value && (
                      <React.Fragment key={item?.name}>
                        {item?.name === 'Model No.' ? (
                          <>
                            <dt>Model</dt>
                            <dd>
                              {item?.value} {productColorCode}
                            </dd>
                          </>
                        ) : (
                          <>
                            <dt>{item?.name}</dt>
                            <dd>{item?.value}</dd>
                          </>
                        )}
                      </React.Fragment>
                    )
                )}
              </dl>
              {specs?.length > 5 && !showAll && (
                <button className="odButton odButton--outline" onClick={() => setShowModal(true)}>
                  +{remainingCount} more Details
                </button>
              )}
            </>
          )}
        </Collapse>
        {showModal && (
          <div
            className="od-pc-technical-details__modal-backdrop"
            onClick={() => setShowModal(false)}
          >
            <div className="od-pc-technical-details__modal" onClick={e => e.stopPropagation()}>
              <div className="od-pc-technical-details__modal-header">
                <h2>{PRODUCT_DETAILS}</h2>
                <button onClick={() => setShowModal(false)}>×</button>
              </div>
              <div className="od-pc-technical-details__modal-body">
                <dl>
                  {productId && (
                    <>
                      <dt>Product ID</dt>
                      <dd>{productId}</dd>
                    </>
                  )}
                  {specs?.map(
                    item =>
                      item?.value && (
                        <React.Fragment key={item?.name}>
                          {item?.name === 'Model No.' ? (
                            <>
                              <dt>Model</dt>
                              <dd>
                                {item?.value} {productColorCode}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>{item?.name}</dt>
                              <dd>{item?.value}</dd>
                            </>
                          )}
                        </React.Fragment>
                      )
                  )}
                </dl>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TechnicalDetails;
